import React, { useState, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CommentIcon from '@mui/icons-material/Comment';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../../store';
import { IModule } from '../../../../components/GestionFonctionnalite/Module/moduleSlice';
import CommonAccordionModule from './Module';
import CommonAccordion from './Module';
import Module from './Module';
import { IModuleDroit } from '../../CreationDroit/Module/moduleDroitSlice';
import { ISousModuleDroit, setFilteredSousModuleDroits, setSousModuleDroits } from '../../CreationDroit/SousModuleDroit/sousModuleDroitSlice';
import { IDroit, setFilterDroits } from '../../CreationDroit/Droit/droitSlice';
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import _ from 'lodash';


interface ISearchProps {
    objModuleDroit: any;
    setObjModuleDroit: any;
    objSousModuleDroit: any;
    setObjSousModuleDroit: any;
    setLocalDroits: any;
    localDroits: any;
}


export default function Search(props: ISearchProps) {
    const dispatch = useDispatch()
    const { objModuleDroit, setObjModuleDroit, objSousModuleDroit, setObjSousModuleDroit, setLocalDroits, localDroits } = props
    const { moduleDroits } = useSelector((state: IReduxState) => state.modulesDroit);
    const { sousModuleDroits ,filteredSousModuleDroits} = useSelector((state: IReduxState) => state.sousModuleDroit);
    const { droits, filterdroits } = useSelector((state: IReduxState) => state.droits);
    const [search, setSearch] = useState("")


    useEffect(() => {
        const droitsParModule: any =
            objModuleDroit.idModuleDroit === undefined
                ? [...droits]
                : _.filter(droits, droit =>
                    _.some(sousModuleDroits.filter(md => md.idModuleDroit === objModuleDroit.idModuleDroit),
                        { 'idSousModuleDroit': droit.idSousModuleDroit }));
        const droitsParSousModule: any =
            objSousModuleDroit.idSousModuleDroit === undefined
                ? [...droitsParModule]
                : droits.filter(md => md.idSousModuleDroit === objSousModuleDroit.idSousModuleDroit)
        setLocalDroits(droitsParSousModule)
        dispatch(setFilterDroits(droitsParSousModule))
    }, [objModuleDroit, objSousModuleDroit])




    useEffect(() => {
        let newArray = []
        if (search === "") {
            newArray = [...filterdroits]
        } else {
            newArray = filterdroits.filter((droit: any) => droit.libDroit.toLowerCase().includes(search.toLowerCase()))
        }
        setLocalDroits(newArray)
    }, [search]);



    return (
        <Box style={{ width: '100%', marginBottom: 15 }}>
            <Grid container spacing={2}>
                <Grid item md={4} xs={12} sm={4}>
                    <Autocomplete
                        fullWidth
                        onChange={(e: any, item) => {
                            if (item) {
                                setObjModuleDroit({ ...objModuleDroit, idModuleDroit: item.idModuleDroit });
                                dispatch(setFilteredSousModuleDroits(sousModuleDroits.filter(md => md.idModuleDroit === item.idModuleDroit)))
                            } else {
                                setObjModuleDroit({})
                                dispatch(setFilteredSousModuleDroits(sousModuleDroits))
                            }
                        }}
                        options={moduleDroits}
                        renderOption={(props, item) => {
                            const { idModuleDroit, libModuleDroit } = item;
                            const newIndex = moduleDroits.findIndex(item => item.idModuleDroit === idModuleDroit)
                            return (
                                <span {...props}
                                    style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                                >
                                    {libModuleDroit}
                                </span>
                            );
                        }}

                        getOptionLabel={(item) =>
                            `${item.libModuleDroit}`
                        }

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Choisir un module"
                            />
                        )}
                    />

                </Grid>

                <Grid item md={4} xs={12} sm={4}>
                    <Autocomplete
                        fullWidth
                        onChange={(e: any, item) => {
                            if (item) {
                                setObjSousModuleDroit({
                                    ...objSousModuleDroit,
                                    idSousModuleDroit: item.idSousModuleDroit
                                });
                            } else {
                                setObjSousModuleDroit({})
                            }
                        }}
                        options={filteredSousModuleDroits}
                        renderOption={(props, item) => {
                            const { idSousModuleDroit, libSousModuleDroit } = item;
                            const newIndex = filteredSousModuleDroits.findIndex(item => item.idSousModuleDroit === idSousModuleDroit)
                            return (
                                <span {...props}
                                    style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
                                >
                                    {libSousModuleDroit}
                                </span>
                            );
                        }}

                        getOptionLabel={(item) =>
                            `${item.libSousModuleDroit}`
                        }

                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                fullWidth
                                size="small"
                                label="Choisir un sous module"
                            />
                        )}
                    />
                </Grid>

                <Grid item md={4} xs={12} sm={4}>
                    <TextField
                        fullWidth
                        size="small"
                        name="libelleModele"
                        label="recherche..."
                        value={search}
                        onChange={(e: any) => setSearch(e.target.value)}
                    />
                </Grid>
            </Grid>
        </Box>
    );
}
